var _polygon, _polygon2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlankCanva(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.59,304.42l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.82,318.53l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.05H40.9v-.45l-.06-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.11,103.14l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45L240.13,92v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27V92c0,1.9-.09,3.79-.13,5.66Zm0,0L267,97.49c0-1.86-.11-3.7-.13-5.54l.28.28c-4.42,0-8.83.16-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.34,117.25l-13.13.28-6.66.11c-2.23,0-4.46,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.71-.13-5.54l.27.28c-4.41,0-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55,0L239,117Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.62,103.14l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45L210.64,92v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28V92c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41,0-8.83.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,318.53l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.89,47.66l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05H417v-.45l0-11.18V36h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0L443.75,42c-.05-1.86-.12-3.7-.14-5.53l.28.27c-4.42,0-8.83.16-13.24.16L417.41,37l.5-.49-.06,11.18-.44-.44c2.18,0,4.35,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.66,61.76,445.53,62l-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.45l-.05-11.18v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.65c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.18-.44-.44c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.87,280.75l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.05h-.45v-.45l-.05-11.19v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.14-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.64,294.86l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.45l0-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,47.66l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.45l-.06-11.18V36h.5L69.35,36c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0L82.45,42c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16L56.11,37l.5-.49,0,11.18-.45-.44c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.32,
    y: 122.47,
    width: 152.54,
    height: 6.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.37,
    y: 128.77,
    width: 6.3,
    height: 20.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.37,
    y: 128.77,
    width: 6.3,
    height: 6.43,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.52,
    y: 128.77,
    width: 6.3,
    height: 20.81,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.52,
    y: 128.77,
    width: 6.3,
    height: 6.43,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.28 101.4 105.05 104.63 104.31 106.59 103.08 109.83 98.31 122.48 72.49 122.48 67.7 109.83 66.48 106.59 65.74 104.63 64.51 101.4 74.04 87.52 69.1 78.36 101.71 78.36 96.75 87.52 106.28 101.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.28 101.4 105.05 104.63 65.74 104.63 64.51 101.4 106.28 101.4",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.31 106.59 103.08 109.83 67.7 109.83 66.48 106.59 104.31 106.59",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.52,
    y: 62.34,
    width: 49.65,
    height: 60.22,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.19,
    y: 67.83,
    width: 38.3,
    height: 49.23,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.19,
    y: 67.83,
    width: 1.49,
    height: 49.23,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.17,
    y: 62.34,
    width: 1.49,
    height: 60.22,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.62 122.51 112.89 122.51 120.96 76.75 158.69 76.75 150.62 122.51",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.04 118.33 117.94 118.33 124.54 80.93 153.64 80.93 147.04 118.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.08 118.33 117.94 118.33 124.54 80.93 125.67 80.93 119.08 118.33",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.75 122.51 150.62 122.51 158.69 76.75 159.82 76.75 151.75 122.51",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.84,
    y: 258.11,
    width: 6.9,
    height: 171.95,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.15,
    y: 258.11,
    width: 111.69,
    height: 171.95,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.32,418.5c-8.48,6.82-13.82-2.18-29.57-2.18s-15.75,1.92-31.51,1.92-20.73,14.14-32,3.14c-11-10.71,2.58-15.87,2.58-31.22s-5.05-15.36-5.05-30.71-1.17-15.36-1.17-30.71,8-15.36,8-30.71-12.12-17.23-1.12-27.95c11.28-11,13.05-6.88,28.81-6.88s15.75,2.37,31.51,2.37,17.76-6.73,29.05,4.27c11,10.71-.81,12.83-.81,28.18s7.74,15.35,7.74,30.71-3,15.35-3,30.71-2.58,15.2.89,30.16C448.49,406.15,448.31,412.07,440.32,418.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.9,264.64a1.73,1.73,0,1,0,1.72-1.73A1.72,1.72,0,0,0,442.9,264.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.64,264.64a1.73,1.73,0,1,0,1.73-1.73A1.72,1.72,0,0,0,343.64,264.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.9,423.54a1.73,1.73,0,1,0,1.72-1.72A1.72,1.72,0,0,0,442.9,423.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.64,423.54a1.73,1.73,0,1,0,1.73-1.72A1.72,1.72,0,0,0,343.64,423.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.68 429.92 318.82 429.92 336.97 299.27 421.83 299.27 403.68 429.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.37 429.92 403.68 429.92 421.83 299.27 429.52 299.27 411.37 429.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.49,
    y: 52.56,
    width: 52.24,
    height: 63.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.46,
    y: 58.34,
    width: 40.3,
    height: 51.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.46,
    y: 58.34,
    width: 1.57,
    height: 51.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.73,
    y: 52.56,
    width: 1.57,
    height: 63.36,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.51,
    y: 70.32,
    width: 9.5,
    height: 28.31,
    transform: "translate(602.52 168.94) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.66,79.85H284.32V65h26.34Zm-25.34-1h24.34V66H285.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.93,
    y: 87.29,
    width: 52.24,
    height: 63.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.9,
    y: 93.08,
    width: 40.3,
    height: 51.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.9,
    y: 93.08,
    width: 1.57,
    height: 51.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.17,
    y: 87.29,
    width: 1.57,
    height: 63.36,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.4,
    y: 105.05,
    width: 9.5,
    height: 28.31,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.1,114.59H418.76V99.72H445.1Zm-25.34-1H444.1V100.72H419.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.71,
    y: 69.92,
    width: 52.24,
    height: 63.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.68,
    y: 75.71,
    width: 40.3,
    height: 51.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.68,
    y: 75.71,
    width: 1.57,
    height: 51.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.95,
    y: 69.92,
    width: 1.57,
    height: 63.36,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.93,
    y: 89.1,
    width: 8.14,
    height: 20.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.14,116.3H353.27V101.11h22.87Zm-21.87-1h20.87V102.11H354.27Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40.39 430.06 92.8 429.82 145.2 429.73 250 429.56 354.8 429.73 407.2 429.82 459.61 430.06 407.2 430.31 354.8 430.4 250 430.56 145.2 430.39 92.8 430.31 40.39 430.06",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.52,
    cy: 455.11,
    rx: 153.48,
    ry: 10.65,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.94,245.07s-26-3.64-19.89-35C216.05,210.09,245.06,216.6,235.94,245.07Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,245.07s-26-3.64-19.89-35C216.05,210.09,245.06,216.6,235.94,245.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.63,238.52a47.09,47.09,0,0,0-1.77-4.67c0-.2-.05-.4-.06-.59,0-.43-.08-.86-.11-1.29-.07-.94-.13-1.88-.19-2.81-.11-1.87-.23-3.75-.26-5.62a.08.08,0,1,0-.15,0c0,1.88-.05,3.75,0,5.63,0,.93.09,1.87.16,2.81,0,.2,0,.41,0,.62a55.39,55.39,0,0,0-5.21-8.9,44.91,44.91,0,0,0-2.84-3.6c-1-1.19-2.12-2.32-3.17-3.49-.07-.08-.18,0-.11.12a45.7,45.7,0,0,1,5,6.65c.79,1.19,1.54,2.42,2.25,3.66L228,227c-.31-.13-.62-.26-.93-.37l-2.12-.81c-1.39-.51-2.79-1-4.18-1.55-.08,0-.14.11,0,.15,1.38.55,2.74,1.13,4.11,1.72l2,.86c.33.15.67.28,1,.42a3,3,0,0,0,.69.24c.52.94,1,1.89,1.52,2.85a67.35,67.35,0,0,1,3.17,7.48c.07.18.13.36.19.54a15.43,15.43,0,0,0-2.13-1l-2.68-1.22c-1.82-.84-3.63-1.69-5.38-2.67a.08.08,0,0,0-.08.14c1.79,1,3.54,2,5.32,3,.9.48,1.8.95,2.71,1.4a8.41,8.41,0,0,0,2.44,1,31.07,31.07,0,0,1,1.7,7.37c.29,3.54.26,7.12.34,10.67,0,.06.09.06.1,0,.25-3.22.4-6.48.41-9.71A27.87,27.87,0,0,0,234.63,238.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.63,220.09a31,31,0,0,0-.25,5.53,0,0,0,1,0,.07,0c.11-1.84.13-3.66.34-5.49C230.8,220,230.65,220,230.63,220.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.21,221.66a20.68,20.68,0,0,1-3.34-1.64c-.08-.06-.16.08-.08.14a12.81,12.81,0,0,0,3.38,1.61C223.23,221.79,223.27,221.69,223.21,221.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.77,294.83c0-2.87-.07-5.73-.1-8.6-.06-9.53-.14-19.06-.31-28.59q-.2-11.35-.53-22.69a.12.12,0,0,0-.06-.1c0-2.07,0-4.13,0-6.2,0-.05-.06-.08-.12-.08s-.12,0-.12.09q0,3.09,0,6.2s-.06,0-.06.09c-.38,13.47-.72,26.93-.8,40.4,0,2.74,0,5.48,0,8.21q-.13,13.17-.1,26.34c0,1.4,0,2.8,0,4.2,0,8,.08,16.06.08,24.1,0,.43.48.64,1,.66s1.21-.21,1.21-.7c0-8.86.06-17.72.06-26.57C236.8,306,236.82,300.42,236.77,294.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.93,286.12s-12.49-9.26-24.34-3-13.72,30.35-13.72,30.35,17.41,2.49,28.37-7.94C226.8,295.47,225.93,286.12,225.93,286.12Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,286.69a14.92,14.92,0,0,0-7.23-.95,11.32,11.32,0,0,0-1.53-.15l-1.76-.13c-1.22-.09-2.43-.16-3.64-.26-2.47-.18-4.94-.33-7.4-.58-.09,0-.1.15,0,.16,2.44.31,4.86.66,7.3.9,1.26.13,2.51.26,3.77.35l.92.09q-.57.12-1.11.27a29.86,29.86,0,0,0-5.66,2.3c-1,.18-2,.45-2.93.68-1.55.37-3.08.76-4.62,1.17-3,.79-6,1.69-9,2.56a.08.08,0,1,0,0,.15c3-.73,6-1.41,9.05-2.13,1.46-.35,2.93-.69,4.39-1.05l1.15-.27a36.74,36.74,0,0,0-8.88,7.72,48.49,48.49,0,0,0-6.17,9.73c0,.09.08.18.13.09a47.17,47.17,0,0,1,7.47-9.8c-.05.17-.11.33-.16.5-.24.73-.47,1.47-.7,2.2-.46,1.48-.93,2.94-1.37,4.42,0,.1.12.13.16,0,.52-1.42,1-2.86,1.53-4.29.24-.71.49-1.41.74-2.11.13-.37.25-.73.37-1.1l.12-.33a45.15,45.15,0,0,1,4.43-3.78,33.79,33.79,0,0,1,6.63-3.8l-.12.64c-.13.57-.25,1.14-.37,1.71-.25,1.18-.48,2.37-.71,3.55-.47,2.42-.76,4.87-1.21,7.28,0,.1.13.14.15,0,.56-2.43,1.28-4.82,1.83-7.26.27-1.22.54-2.43.79-3.65.12-.58.24-1.15.35-1.72.07-.32.14-.63.18-.95.22-.09.45-.2.68-.28,3.27-1.22,6.89-2.1,10.39-1.43a10.21,10.21,0,0,1,7.51,6c.12.27.55.1.48-.18C234.58,290.07,232.08,287.84,229.33,286.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.21,297l-1.05,4.75a34.5,34.5,0,0,0-.87,4.62c0,.06.08.06.1,0a35.17,35.17,0,0,0,1.06-4.65c.31-1.57.61-3.13.92-4.69A.08.08,0,0,0,210.21,297Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,301c-1.59.81-3.13,1.73-4.79,2.39a.08.08,0,1,0,.07.14,49.87,49.87,0,0,0,4.76-2.47S198.17,301,198.13,301Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,269.12s-15.27,1-22.37-9.09-5.51-24.44-5.51-24.44,16,1.95,22.41,9.18S228.74,269.12,228.74,269.12Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.9,284.18c-.53-1.63-1.18-3.24-1.8-4.85s-1.23-3.06-1.9-4.57a93.64,93.64,0,0,0-4.57-9c-1.08-1.86-2.23-3.66-3.42-5.43,0-.27-.08-.54-.12-.82-.07-.47-.14-.94-.22-1.41-.15-1-.32-1.93-.48-2.9-.35-2.11-.78-4.2-1.12-6.31,0-.1-.17-.1-.16,0,.31,2.09.52,4.18.81,6.27.15,1,.28,2.05.44,3.07,0,.37.11.74.17,1.11a109.61,109.61,0,0,0-7.55-9.8l-1.12-1.25a3.19,3.19,0,0,0-.14-.35l-.33-.87-.66-1.82c-.43-1.2-.81-2.4-1.14-3.63,0-.1-.17,0-.15.05.31,1.25.63,2.5,1,3.74.18.59.37,1.18.58,1.77,0,.1.08.2.11.3-1.95-2.13-4-4.18-6-6.21-.07-.07-.18.05-.11.12a108.4,108.4,0,0,1,10.82,13.25,9.88,9.88,0,0,0-1.13-.29c-1.18-.23-2.36-.39-3.55-.54-2.49-.32-5-.63-7.44-1-.1,0-.14.14,0,.16,2.36.46,4.71,1,7.06,1.54,1.1.25,2.22.47,3.33.69a22.18,22.18,0,0,1,2.68.76l.75,1.06c1.12,1.63,2.19,3.29,3.25,5l-1.56-.3c-1.18-.23-2.36-.45-3.55-.64-2.33-.39-4.66-.79-7-1.31a.08.08,0,0,0,0,.15c2.34.55,4.65,1.19,7,1.8,1.11.3,2.24.58,3.37.82l1.7.37a3.57,3.57,0,0,0,.69.12c2.22,3.61,4.32,7.32,6.26,11.09q1.28,2.49,2.46,5c.82,1.73,1.52,3.5,2.27,5.26C235.47,284.71,236,284.57,235.9,284.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.28,249.1c-.29-1.45-.6-2.91-.92-4.36,0-.1-.17-.05-.15,0,.28,1.43.56,2.86.82,4.3a42.14,42.14,0,0,0,.87,4.28s0,0,0,0A29.24,29.24,0,0,0,220.28,249.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37,248.68a23.58,23.58,0,0,0-2.19-.93L208,247.3l-.59-.24a2.44,2.44,0,0,1-.64-.28c-.12-.09-.19.12-.08.14a2.67,2.67,0,0,1,.66.26l.57.26,1.12.5a21.92,21.92,0,0,0,2.25.89A.08.08,0,0,0,211.37,248.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,257.12s9.24-17.26,23.3-19.93S290.31,249,290.31,249s-10.25,13.09-23.15,15.38S244.36,257.12,244.36,257.12Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.08,244.92a37.77,37.77,0,0,0-11,.14c.21-.12.42-.24.63-.34l3.12-1.61c2.16-1.12,4.34-2.32,6.6-3.22a.08.08,0,1,0-.07-.14c-2.2,1-4.47,1.88-6.68,2.89-1.1.51-2.19,1-3.26,1.61-.69.37-1.46.71-2.14,1.15a39.28,39.28,0,0,0-8.94,3c.59-.64,1.18-1.27,1.76-1.91,1.31-1.44,2.6-2.94,4-4.25.07-.07,0-.18-.12-.11-1.47,1.34-3,2.57-4.45,4-.69.68-1.35,1.37-2,2.09-.32.36-.64.73-.95,1.11a37,37,0,0,0-18.84,25.45c0,.1.12.15.15.05a42.37,42.37,0,0,1,10.33-17.48,40.72,40.72,0,0,1,18.83-10.9,41.24,41.24,0,0,1,13-1.18A.14.14,0,0,0,277.08,244.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.32,249s-10.26,13.09-23.16,15.38c-9.84,1.74-17.93-3.39-21.22-5.92l-.71-1.16s6.66-5.61,19.24-8.85S290.32,249,290.32,249Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.91,238.77a37.34,37.34,0,0,0-3.12,2.06,20.55,20.55,0,0,0-2.71,2.48.09.09,0,0,0,.12.12c.93-.81,1.87-1.62,2.84-2.39a28.07,28.07,0,0,1,3-2.13A.08.08,0,0,0,268.91,238.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,241.69c-.52.22-1.06.41-1.58.62l-1.56.65c-.11,0-.06.23.05.19l1.57-.64c.53-.21,1-.45,1.56-.67C276.77,241.81,276.72,241.65,276.63,241.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.52,278.84S245,296,257.86,301.94s28.57,0,28.57,0S280.25,264.91,242.52,278.84Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.56,290.81c-1.19-.14-2.37-.34-3.55-.55l-1.73-.33c-.29-.06-.59-.13-.9-.18l-1-1a52.39,52.39,0,0,0-7.87-5.7,44.75,44.75,0,0,0-4.72-2.43H258l4.24.19c2.82.13,5.65.19,8.47.37.1,0,.1-.15,0-.16-2.84-.19-5.66-.5-8.49-.74L258.1,280l-2.12-.18-.55-.06c-.73-.28-1.47-.53-2.22-.77a20.12,20.12,0,0,0-10.9-.6c-3.24.83-6.47,3-7.31,6.37,0,.12.15.2.2.08,1.21-2.86,4.38-4.29,7.24-4.88a17.29,17.29,0,0,1,5.83-.12,13.1,13.1,0,0,0,.65,2.59c.35,1.2.7,2.41,1.07,3.61.73,2.41,1.53,4.79,2.24,7.2a.08.08,0,0,0,.15-.05c-.59-2.4-1.1-4.83-1.68-7.23-.28-1.19-.58-2.36-.87-3.54a21.57,21.57,0,0,0-.65-2.44,31.19,31.19,0,0,1,3.34.79,47.38,47.38,0,0,1,5.83,2.14c.19,1.22.47,2.43.75,3.63.35,1.51.74,3,1.22,4.49a.07.07,0,0,0,.14-.05,2.33,2.33,0,0,1,0-.28h0c-.29-1.4-.59-2.8-.89-4.2-.24-1.12-.46-2.26-.7-3.38a51.58,51.58,0,0,1,4.69,2.38c0,.34.12.7.17,1,.09.59.2,1.17.3,1.76.25,1.32.51,2.63.83,3.94a60.47,60.47,0,0,0,2.21,7.44.08.08,0,0,0,0,.1l.07.09a.08.08,0,0,0,.13-.08c-.59-2.54-1.27-5.06-1.83-7.6-.28-1.27-.56-2.54-.81-3.82-.13-.64-.25-1.28-.37-1.92q0-.27-.09-.57a55.36,55.36,0,0,1,5,3.34,54.77,54.77,0,0,1,7.67,7c.09.1.27,0,.19-.16-1-1.29-2-2.55-3.07-3.74-.65-.69-1.32-1.36-2-2l.22,0c.6.1,1.2.19,1.81.27,1.19.16,2.39.28,3.58.41C277.62,291,277.66,290.82,277.56,290.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.51,296.61h0c0-.15,0-.29-.07-.44s-.13-.37-.16-.56h0c-.27-1.14-.49-2.29-.7-3.45,0-.08-.14-.06-.14,0a14.27,14.27,0,0,0,1,4.47c0,.05.1,0,.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,296.34a.08.08,0,0,0-.08-.07c-.36-1.52-.71-3-1-4.56-.17-.81-.33-1.61-.49-2.41l-.24-1.3a3.83,3.83,0,0,0-.27-1.12.09.09,0,0,0-.15,0,7.46,7.46,0,0,0,.32,2.29c.16.84.32,1.67.51,2.5.37,1.69.79,3.38,1.27,5,0,.09.18.07.17,0S257.75,296.46,257.74,296.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.38,285.88c-2.35-.32-4.7-.66-7.05-.95-.1,0-.14.14,0,.15,2.35.35,4.7.64,7.06.95C276.44,286,276.48,285.89,276.38,285.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.92,238.69s-7.87-34.56,29.26-48.54C265.18,190.15,275.47,235.64,235.92,238.69Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.94,219.09l.4-.24,2.1-1.17,4.3-2.41c2.84-1.59,5.63-3.24,8.49-4.79.09,0,0-.18-.09-.13-2.85,1.55-5.76,3-8.64,4.53l-4.25,2.25-1.74.91c1.24-2.34,2.56-4.65,4-6.87,1.94-3,4.07-5.78,6.28-8.53a.13.13,0,0,0-.18-.18A58.78,58.78,0,0,0,246,213c0-.13,0-.25,0-.36,0-.86.06-1.72.07-2.58,0-1.69-.05-3.38,0-5.06a.08.08,0,0,0-.16,0c-.07,1.66-.27,3.31-.36,5,0,.83-.09,1.66-.11,2.49,0,.45-.06,1,0,1.45-.77,1.21-1.5,2.45-2.19,3.7a63.47,63.47,0,0,0-3.32,7c0-.86-.09-1.72-.14-2.58-.11-1.89-.34-3.78-.42-5.67,0-.1-.16-.1-.16,0,0,1.9-.05,3.79,0,5.68,0,.95.06,1.89.12,2.84l.06,1a63.63,63.63,0,0,0-2.8,9.5,101.78,101.78,0,0,0-1.38,10.44s0,0,0,0a54.88,54.88,0,0,1,2-9.31c.46-1.63.94-3.25,1.46-4.86,1.55-.73,3-1.64,4.52-2.47l4.66-2.54c3.09-1.7,6.19-3.43,9.38-4.93.1-.05,0-.18-.08-.14-3.24,1.47-6.5,2.86-9.68,4.46-1.58.79-3.14,1.64-4.68,2.51-1.29.73-2.61,1.46-3.84,2.29.36-1.07.73-2.15,1.14-3.2A91.86,91.86,0,0,1,243.94,219.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.81,211.19c0-.1-.17-.1-.16,0,.13,2,.2,3.95.41,5.91,0,.11.18.11.17,0C241.17,215.12,241,213.16,240.81,211.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,217.79c-2.32.93-4.67,1.82-7,2.79-.06,0,0,.13,0,.11,2.35-.88,4.66-1.84,7-2.75C258.75,217.9,258.71,217.75,258.61,217.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.14,201.85a60.6,60.6,0,0,0-6.6,3.54c-.11.07,0,.24.1.17,2.15-1.26,4.35-2.47,6.58-3.57C262.32,201.94,262.23,201.81,262.14,201.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.03,
    y: 313.42,
    width: 53.55,
    height: 56.44,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.35,
    y: 333.39,
    width: 2.74,
    height: 96.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.24,
    y: 333.39,
    width: 2.74,
    height: 96.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.75,
    y: 333.39,
    width: 2.74,
    height: 96.68,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.72,
    y: 366.24,
    width: 57.89,
    height: 7.81,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Canvas--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.45,
    y: 354.6,
    width: 83.75,
    height: 3.96,
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.45,
    y: 354.6,
    width: 83.75,
    height: 3.96,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.19 449.42 261.7 449.42 314.21 67.13 308.1 67.73 244.19 449.42",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.19 449.42 261.7 449.42 314.21 67.13 308.1 67.73 244.19 449.42",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.92 289.26 316.21 289.26 333.38 39.53 328.27 40.08 301.92 289.26",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.92 289.26 316.21 289.26 333.38 39.53 328.27 40.08 301.92 289.26",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.86 449.42 357.97 449.42 348.43 63.34 342.43 63.94 340.86 449.42",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "340.86 449.42 357.97 449.42 348.43 63.34 342.43 63.94 340.86 449.42"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "285.29 277.67 284.47 283.67 271.94 283.67 272.95 277.67 285.29 277.67",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.01 277.67 316.62 283.67 302.51 283.67 303.15 277.67 317.01 277.67",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.88 283.67 341.54 283.67 341.56 277.67 353.73 277.67 353.88 283.67",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.46 150.39 370.46 180.6 418.66 420.06 432.46 420.06 370.46 150.39",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.46 150.39 370.46 180.6 418.66 420.06 432.46 420.06 370.46 150.39"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "391.75 242.95 388.85 271.95 370.46 180.6 370.46 150.39 391.75 242.95",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.42 270.5 247.54 270.5 267.55 94.66 384.95 94.66 380.42 270.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.91,271H247L267.11,94.16H385.46v.52ZM248.1,270H379.93l4.5-174.84H268Z",
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.56 94.09 390.38 102.49 387.08 270.5 380.83 270.5 385.56 94.09",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.63 278.42 393.4 278.42 392.4 270.5 241.63 270.5 240.63 278.42",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.63 278.42 393.4 278.42 392.4 270.5 241.63 270.5 240.63 278.42",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.61 95.68 367.38 95.68 366.38 87.76 289.61 87.76 288.61 95.68",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.61 95.68 367.38 95.68 366.38 87.76 289.61 87.76 288.61 95.68",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.21,455.24c-2.23.7-65.63-.66-68-2.24-.9-.59-1.24-9.84-1.33-21,0-2.42,0-4.9,0-7.44,0-3,0-6,.06-9,.17-13.24.57-24.9.57-24.9l41.27.77-.48,24.9-.18,9-.35,7.44s24,11.38,26.47,13.39S218.44,454.56,216.21,455.24Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.21,455.24c-2.23.7-65.63-.66-68-2.24-.9-.59-1.24-9.84-1.33-21,0-2.42,0-4.9,0-7.44,0-3,0-6,.06-9l41.36.77-.18,9-.35,7.44s24,11.38,26.47,13.39S218.44,454.56,216.21,455.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,455.34c-1.45.45-28.46.05-48.11-.73-4.55-.18-8.71-.38-12.06-.59-4.63-.3-7.72-.61-8.22-.94-1.11-.73-1.39-14.3-1.38-28.62l41.48.77-.35,7.48s24.17,11.44,26.62,13.46S218.64,454.63,216.4,455.34Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.54,452.77c-10.68-.49-53.8-1.46-64.4-1.14-.09,0-.09.06,0,.07,10.58.72,53.71,1.34,64.4,1.25C215.76,452.94,215.77,452.78,215.54,452.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.32,430.37c-4.19-.88-9.34-.34-12.62,2.58-.13.12,0,.3.17.26a58.88,58.88,0,0,1,12.42-2.31A.27.27,0,0,0,189.32,430.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.32,432.26c-4.19-.88-9.35-.34-12.63,2.59-.12.11,0,.29.18.25a58.76,58.76,0,0,1,12.42-2.31A.27.27,0,0,0,192.32,432.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.31,434.15c-4.19-.87-9.34-.34-12.62,2.59-.13.12,0,.29.17.25a60.15,60.15,0,0,1,12.43-2.31A.27.27,0,0,0,195.31,434.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.31,436.05c-4.19-.88-9.35-.34-12.62,2.59-.13.11,0,.29.17.25a58.88,58.88,0,0,1,12.42-2.31A.27.27,0,0,0,198.31,436.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.3,420.81c-1.61-2.31-4.71-1.36-6.49.08a22.43,22.43,0,0,0-6.69,9.5c0,.08,0,.13.1.15a.52.52,0,0,0,.65.54c3.5-1.21,7.39-2.07,10.41-4.32C197.05,425.44,198.81,423,197.3,420.81Zm-7.5,7.35c-1.71.63-3.44,1.18-5.12,1.88a66.61,66.61,0,0,1,4-5.45,23.11,23.11,0,0,1,2.28-2.36c1.27-1.12,6.28-3.43,5.44,1.16C196,425.93,191.83,427.4,189.8,428.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,429.06c3.43,1.55,7.42,1.56,11.1,2a.53.53,0,0,0,.52-.67.12.12,0,0,0,.06-.17,22.52,22.52,0,0,0-8.56-7.85c-2.05-1-5.29-1.29-6.36,1.31S171.45,428.15,173.46,429.06Zm-1.84-3c-1.8-4.31,3.59-3.12,5.07-2.31a26.43,26.43,0,0,1,2.73,1.82,65.88,65.88,0,0,1,5.1,4.48c-1.79-.33-3.6-.5-5.4-.76C177,429,172.62,428.4,171.62,426Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,455.11c-5.33-.13-10.73-.31-15.67-.5-4.54-.17-8.7-.38-12.05-.59-4.62-.3-7.73-.6-8.22-.94-1-.64-1.31-11.13-1.36-23.34C156.06,436,174.55,448.67,184,455.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.81,432.22l-47.1,0s2.58-129,2.07-131.44c-1.21-5.9-28-99.38-28-99.38l37.2.64,10.43.23s1.17,15.56,1.62,17.21c6.21,22.68,18.35,61.4,20.82,75.76C193.14,320.17,191.81,432.22,191.81,432.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.28,424.35c-7.34-.19-33.37-1-43.17-.23-.07,0-.07.13,0,.14,3.36.55,35.82.39,43.17.29A.1.1,0,1,0,190.28,424.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48,298.49c-1.41-5.73-11.9-41.44-15.11-52.72s-6.22-22.6-9-34c-.35-1.44-.7-2.88-1.09-4.32,0-.12-.2-.06-.18,0,1.06,5.74,2.46,11.42,3.8,17.09s2.79,11.33,4.3,17q4.56,17,9.95,33.72c1.8,5.56,4.76,17,6.34,22.61s-1,120.9-.84,122.39a.34.34,0,0,0,.67,0C149.54,409.41,151.87,304.15,150.48,298.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,202.09s-9.09,99.22-9.2,98.74c-1.17-5.71-26.35-93.62-27.93-99.11,0-.18-.07-.27-.07-.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,460.68c-2.24.69-65.64-.67-68-2.24-.9-.59-1.25-9.85-1.34-21,0-2.41,0-4.9,0-7.44,0-3,0-6,.06-9,.17-13.25,1.53-24.9,1.53-24.9l40.31.76-.48,24.9-.17,9-.35,7.44s24,11.38,26.46,13.4S168.38,460,166.16,460.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,460.68c-2.24.69-65.64-.67-68-2.24-.9-.59-1.25-9.85-1.34-21,0-2.41,0-4.9,0-7.44,0-3,0-6,.06-9l41.36.76-.17,9-.35,7.44s24,11.38,26.46,13.4S168.38,460,166.16,460.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,460.77c-1.46.45-28.46.05-48.12-.72-4.55-.18-8.71-.39-12.06-.59-4.62-.3-7.72-.61-8.22-.94-1.1-.74-1.39-14.31-1.37-28.62l41.48.76-.36,7.48s24.18,11.44,26.62,13.47S168.58,460.07,166.35,460.77Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49,458.2c-10.69-.49-53.81-1.46-64.41-1.13-.08,0-.08.06,0,.06,10.58.72,53.71,1.35,64.4,1.25C165.71,458.38,165.71,458.22,165.49,458.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.26,435.8c-4.18-.88-9.34-.34-12.62,2.59-.13.11,0,.29.17.25a58.86,58.86,0,0,1,12.43-2.31A.27.27,0,0,0,139.26,435.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26,437.69c-4.19-.87-9.35-.34-12.62,2.59-.13.11,0,.29.17.25a59.52,59.52,0,0,1,12.42-2.31A.27.27,0,0,0,142.26,437.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.26,439.59c-4.19-.88-9.35-.34-12.63,2.59-.12.11,0,.29.18.25a58.76,58.76,0,0,1,12.42-2.31A.27.27,0,0,0,145.26,439.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.25,441.48c-4.19-.87-9.34-.34-12.62,2.59-.13.11,0,.29.17.25A59.52,59.52,0,0,1,148.22,442,.27.27,0,0,0,148.25,441.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.24,426.24c-1.6-2.31-4.7-1.35-6.49.08a22.4,22.4,0,0,0-6.68,9.5.1.1,0,0,0,.09.15c0,.32.29.67.65.54,3.5-1.21,7.39-2.07,10.42-4.32C147,430.88,148.76,428.43,147.24,426.24Zm-7.5,7.35c-1.71.64-3.43,1.19-5.12,1.89a65.09,65.09,0,0,1,4-5.46,23.11,23.11,0,0,1,2.28-2.36c1.27-1.11,6.28-3.43,5.44,1.17C145.91,431.36,141.78,432.83,139.74,433.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.4,434.49c3.44,1.55,7.42,1.56,11.1,2,.38.05.58-.35.52-.67a.11.11,0,0,0,.06-.17,22.42,22.42,0,0,0-8.56-7.84c-2-1-5.28-1.3-6.36,1.3S121.4,433.59,123.4,434.49Zm-1.83-3c-1.81-4.31,3.58-3.12,5.06-2.3a22.73,22.73,0,0,1,2.73,1.82,63.7,63.7,0,0,1,5.1,4.47c-1.79-.33-3.6-.49-5.4-.75C126.91,434.38,122.56,433.83,121.57,431.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45,437l-45.7-.84S106.57,248.52,106,239.66c-.72-10.86-.39-30.62,6.49-38.36l44.53.82s-1.18,14.44-2.63,19c0,0-5.68,3.44-7.73,4.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.19,428.91c-6.93-.31-4.93-.32-11.87-.55-3.39-.12-25.69-.84-28.87-.39a.07.07,0,0,0,0,.14c3.16.6,25.46.94,28.85,1,6.94.09,5,0,11.89,0A.1.1,0,0,0,139.19,428.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.74,220.06a85.72,85.72,0,0,0-12.65,7.19.14.14,0,0,0,.14.25c4.28-2.26,8.66-4.46,12.8-6.95C156.36,220.36,156.08,219.91,155.74,220.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.08,219.32a19.29,19.29,0,0,0-.65,2.62,5.44,5.44,0,0,0-.17,2.12c0,.13.21.13.28,0a7.5,7.5,0,0,0,.73-2.12c.23-.81.47-1.62.68-2.44C151.08,219,150.26,218.79,150.08,219.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,215c.14-.74.27-1.48.42-2.22s.36-1.53.45-2.3c0-.12.21-.09.19,0-.13.74-.16,1.51-.23,2.26s-.16,1.51-.25,2.26c-.17,1.4-.43,2.81-.74,4.19a5,5,0,0,0,2.06-.81,3.91,3.91,0,0,0,1.14-2.13c.24-.84.44-1.7.68-2.54a16.62,16.62,0,0,0,.71-2.84c0-.12.2-.08.19,0a30.73,30.73,0,0,1-1.25,6,3.27,3.27,0,0,1-1.15,2,6.27,6.27,0,0,1-2.51.69c-.1.05-.25,0-.24-.12C149.35,218,149.5,216.48,149.76,215Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.23,239.22c-.26-3.28-.73-6.54-1-9.81a60.88,60.88,0,0,1,1.55-19.58.1.1,0,0,0-.19-.05c-1.19,5.67-2.24,11.35-2.06,17.17s1.09,11.49,1.07,17.28-.58,11.71-1.06,17.54l-1.46,17.62c-2,23.6-3.8,70.15-5.68,93.76q-.78,9.89-1.52,19.77c-.51,6.71-1.29,23.25-1.66,30,0,.58.83.55.89,0,1.23-11.83,2.21-33.56,3.19-45.42s1.87-23.49,2.8-35.23,1.86-46.43,2.78-58.18q.69-8.81,1.34-17.61c.45-5.85,1-11.7,1.19-17.56A88.93,88.93,0,0,0,113.23,239.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,209.71a.1.1,0,0,0-.18,0,7.57,7.57,0,0,0-.46,2.39,16.27,16.27,0,0,1-.66,2.58,10.24,10.24,0,0,1-2.76,4.45c-2.85,2.57-6.62,3.47-10.25,4.29-.14,0-.09.21,0,.22a16.2,16.2,0,0,0,6.32-.87,13.36,13.36,0,0,0,4.93-2.63,9.09,9.09,0,0,0,2.71-4.72,15.43,15.43,0,0,0,.36-2.88c0-.46,0-.93,0-1.39A3.75,3.75,0,0,0,129.55,209.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,85.37c3.91-2.93,13.65-4.39,19.86,2.11,9.28,9.73,4.38,41.24,2.09,45.62,0,0-21.51,4.34-39.38-6.3,0,0,10.83-20.82,12.78-31.31C134.17,89.22,135.43,87,137.66,85.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.75,103.78c-.09.2-.17.39-.26.58a44.59,44.59,0,0,1-4.15,6.93,26.89,26.89,0,0,1-5.21,5.65s-.13,0-.07-.08a24.43,24.43,0,0,0,4.93-6.1A65.8,65.8,0,0,0,129.7,104a63.14,63.14,0,0,0,5-14.79c0-.1.19-.07.18,0-.09.72-.19,1.44-.31,2.15a.09.09,0,0,1,.1.11,71.1,71.1,0,0,1-3.64,14A53.67,53.67,0,0,1,123.85,118a66.25,66.25,0,0,1-5.22,6.13,0,0,0,0,1,0,0A69.31,69.31,0,0,0,130.75,103.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,86.16c9.72,7.72,11.21,20.74,9.76,32a92,92,0,0,1-3.28,13.28c0,.06-.12,0-.1,0,1.46-5.89,3.19-14.9,2.92-21-.25-5.65-1.06-11.55-3.64-16.72a21.54,21.54,0,0,0-5.75-7.35C154.68,86.23,154.77,86.08,154.86,86.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77,135c1.77,6.67,15.57,38.14,28.92,43.69,8,3.34,35.85-12.81,40.42-17.37,2.1-2.1-10.65-22.62-13.54-21.3-3.3,1.51-21.75,14.38-23.08,14-2.28-.69-16.31-17.55-26.39-24.57C151.13,125.23,149.52,130.27,150.77,135Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,165.51c2-.35,10-1.64,15.65-7.95.6-5.2,2.56-16.13,3.18-18.83.19-3.13,1.36-7.72,1.66-7.65.56.14,2.54.6,5,1,3.24.49,7.29.83,10,.05a3.55,3.55,0,0,0,2.79-2.41c.52-2.21-4.27-3.56-9.81-5.67-7.54-2.87-16.17-6.77-20-4.67-5.61,3.11-8.48,11.47-10,14-2.18,3.6-5.63,8.17-5.63,8.17C204.65,157.11,209.83,165.76,211.2,165.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.64,134.7s-10-1.91-20.18-4.33-33.22-3.16-33.74-2.46S223,134,233.33,135.16s20.79,1.69,20.79,1.69Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.88 134.62 248.08 133 247.57 136.75 254.44 137.15 254.88 134.62",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.88,134.62a5.49,5.49,0,0,1,5,.37,5.3,5.3,0,0,0,4.18.71s-4.85,4.65-9.64,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,135.63c-.36-.17-2,.43-3.35-.21s-2.92,3.34-1,2.83C262.16,137.67,265,136,264.34,135.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.48,160.22c2-1.21,14.48-12.08,15.88-15.56s11.15-9,5.33-11.08-13.22,7.78-14.41,6.64a2.19,2.19,0,0,1-.25-1.49C229.41,141.43,224.08,155,223.48,160.22Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54,170.11l10.54-24.57s-9.83-10.11-19.65-16.8-10.66,3.52-3.54,17.94S166.54,170.11,166.54,170.11Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.57,163.28c2.05-5.4,4.49-10.66,7-15.87q1.07-2.21,2.25-4.36s.09,0,.07,0c-1.09,2.68-2.28,5.31-3.46,8s-2.38,5.28-3.64,7.89c-.71,1.48-1.41,3-2.15,4.41C163.64,163.38,163.54,163.35,163.57,163.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,151.94l-7.8,18.18s-5.54-9-12.65-23.43c-3.87-7.85-5.39-14.45-4.39-17.77C155.36,135.7,167.46,146,174.34,151.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.59,210.64c.15.18,67.83-.35,68.44-1,.85-1-15.23-74.14-22.27-83.13-1.51-1.92-6.42-2.4-10.58-1.84a19.15,19.15,0,0,0-3.2.69l-.11,0a8,8,0,0,0-2.34,1.18c-11.49,9.38-20.9,41.84-23.07,51.58C108.86,194.14,105,210,105.59,210.64Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,135.06c-3.26,9.55-23.2,44.76-23.31,46.65,0,0-22.22,10.55-23.82-1.79s23.69-36.69,36.33-46.33C131.31,128.72,138.39,127.27,135.72,135.06Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,154.79l26.51,3.53s7.08-12.2,10.88-23.46-6.27-9.31-18.24,1.43S100,154.79,100,154.79Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.45,157.84l3,.22c.12-.33,2.53-5.52,3.13-6.64,1.21-2.27,2.55-4.49,3.86-6.71a.06.06,0,1,1,.11.06c-.93,1.94-1.83,3.9-2.79,5.84.24-.26.47-.52.69-.79.46-.54.88-1.12,1.31-1.68,0,0,.12,0,.09.06a10.51,10.51,0,0,1-1.56,2.23,9.27,9.27,0,0,1-.84.82l-.24.48c-.58,1.13-3.49,6.7-3.59,6.68s-2.93-.34-3.23-.39C123.37,158,123.38,157.83,123.45,157.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.08,150.4c5.76.52,11.48,1.45,17.18,2.49,1.61.29,3.21.62,4.81,1,0,0,0,.08,0,.07-2.87-.32-5.72-.76-8.58-1.18s-5.73-.87-8.58-1.38c-1.61-.28-3.22-.57-4.83-.88C105,150.49,105,150.39,105.08,150.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,127.51s.67,30.72.11,33.51c-3.05,15.24-5.51,32.68-5.51,33.88,0,.59-21,6.38-21,6.38l-.36,2.64,12,.72s-3.72,54.17-6.42,71.89c-.68,4.42-5.58,32.6-5.58,32.6s20.22,9.32,42.19,8.6c8.75-.29,46.57-10.46,46.57-10.46s2.15-23.95-3-45.09c-7.32-30.1-18.83-64.64-21.91-83.51C166.34,160,155.53,127,155.53,127L152,125.49l5.41,22.23a82.48,82.48,0,0,1-17.58.19L136.3,126Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44,232.42s.68,9.16,1.8,18.61-.62,30.21-1.31,30.6-3.14-20.7-3.12-30.08.64-18.88.64-18.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.53 232.22 134.28 238.5 130.86 238.57 131.21 232.35 133.53 232.22",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53,232.22a5,5,0,0,0,.2-4.56,4.78,4.78,0,0,1-.21-3.82s-4.69,3.87-2.31,8.51Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.53,232.22a5,5,0,0,0,.2-4.56,4.78,4.78,0,0,1-.21-3.82s-4.69,3.87-2.31,8.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M148.35,241s-4,6.41-8.48,12.85S128.66,276.05,129,276.6s10.27-13.84,13.88-20.68,6.82-14,6.82-14Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.37 240.81 145.39 245.09 147.86 246.47 150 241.8 148.37 240.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,240.81c1.13-3.82,4.91-6.29,4.91-6.29s.25,4.83-3.28,7.28Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.37,240.81c1.13-3.82,4.91-6.29,4.91-6.29s.25,4.83-3.28,7.28Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M142.71,230.18s-.64,7.54-1,15.37-4.41,24.48-5,24.72.12-17.24,1.35-24.87,3-15.28,3-15.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.81 230.03 142.61 235.24 139.82 234.85 140.91 229.83 142.81 230.03",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,229.83s1.79.22,1.9.2a42.89,42.89,0,0,0,2.46-4.94c-.08-.16-6.07-.63-6.16-.08S140.91,229.83,140.91,229.83Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.91,229.83s1.79.22,1.9.2a42.89,42.89,0,0,0,2.46-4.94c-.08-.16-6.07-.63-6.16-.08S140.91,229.83,140.91,229.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.06,252.1l27.64-.34s1.6,26.08,1.36,26.62-12.16,6.65-15.22,5.91-13.06-4.43-13.63-6S122.06,252.1,122.06,252.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88,151.29a1.79,1.79,0,1,1-1.79-1.79A1.79,1.79,0,0,1,139.88,151.29Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,149.56a1.43,1.43,0,1,1-1.7-1.49C160.06,147.92,160.82,148.58,161,149.56Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21,135.82c-3.69,1.1-10.43-4.23-13.24-8.71-.19-.31.1-3.68.26-7.79.09-2.5.12-5.28,0-7.82,0-.52,16.17,2.93,16.17,2.93a40.37,40.37,0,0,0-1,9.85,6.64,6.64,0,0,0,.17,1,1.46,1.46,0,0,1,0,.17C153.05,127.45,153.77,134.75,150.21,135.82Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19,111.51c1,4.25,4.27,14.47,12.79,14.16a9.78,9.78,0,0,0,1.62-.18.74.74,0,0,0,0-.17,6.64,6.64,0,0,1-.17-1,40.37,40.37,0,0,1,1-9.85S141.68,111.93,138.19,111.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.27,91.09c-2.17,5.51-.48,22,3.25,26,5.4,5.73,14.88,7,19.92.35,4.87-6.44,2.29-27.95-1.93-31.61C151.29,80.44,139.47,83,136.27,91.09Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.84,102.67s-.09.07-.08.11c.14,1.11.12,2.41-.85,2.88,0,0,0,.07,0,.06C151.14,105.43,151.15,103.7,150.84,102.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.73,101.61c-1.81,0-1.6,3.64.07,3.61S151.24,101.58,149.73,101.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.32,102.19s.09,0,.09.09c0,1.12.25,2.4,1.28,2.71,0,0,0,.07,0,.07C157.44,105,157.17,103.26,157.32,102.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.25,101c1.79-.24,2.14,3.36.48,3.58S156.75,101.17,158.25,101Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42,100.6a14.86,14.86,0,0,0,1.49.07,2.4,2.4,0,0,0,1.52-.21.78.78,0,0,0,.24-.91,1.88,1.88,0,0,0-1.7-.9,2.79,2.79,0,0,0-1.94.51A.82.82,0,0,0,148.42,100.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,97.66a12.18,12.18,0,0,1-1.48,0,2.41,2.41,0,0,1-1.52-.27.78.78,0,0,1-.2-.92,1.91,1.91,0,0,1,1.73-.83,2.78,2.78,0,0,1,1.92.58A.81.81,0,0,1,159.76,97.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,113c.28.25.57.6,1,.61a3,3,0,0,0,1.18-.35s.08,0,.06,0A1.51,1.51,0,0,1,151,114a1.19,1.19,0,0,1-.93-.94C150,113,150.1,113,150.14,113Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,109.6a3.84,3.84,0,0,0,2.64,1.55,4.84,4.84,0,0,0,1.37,0,1.09,1.09,0,0,0,.26,0,1.23,1.23,0,0,0,.25,0,.29.29,0,0,0,.21-.26h0a.41.41,0,0,0,0-.11h0v-.1c0-.86-.19-2.17-.19-2.17.33.14,2,.77,1.92.32a57.43,57.43,0,0,0-2.14-11.43.11.11,0,0,0-.21,0c.28,3.58,1.19,7.09,1.53,10.68a7,7,0,0,0-1.83-.44c-.12,0,.36,2.52.34,2.91v0a5.29,5.29,0,0,1-4-1C151.13,109.43,151.05,109.51,151.12,109.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61,110.79a4.48,4.48,0,0,1-1.79,1.42,2,2,0,0,1-1.24.1c-.9-.22-.93-1-.78-1.75a5,5,0,0,1,.39-1.08A5.83,5.83,0,0,0,154.61,110.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.82,112.21a2,2,0,0,1-1.24.1c-.9-.22-.93-1-.78-1.75A2.12,2.12,0,0,1,152.82,112.21Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,114a2.36,2.36,0,0,0,2.22.72,2.72,2.72,0,0,1-1,1.83l.21-.7a4.88,4.88,0,0,1-1.55,1.84,2.83,2.83,0,0,1-.1-1.6l-.26.84A3.41,3.41,0,0,1,149.58,114Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.86,105.39c1-.7,2.85-5.94,2.85-5.94s10.69-2.68,13.1-11.73c0,0,3.36,6.43,7.48,8.19,0,0,.58-10.07-7.12-12.2,0,0-7.68-4.57-16,2.62s-2.93,18.92-2.93,18.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.78,85.94a8.75,8.75,0,0,1-.9,4.59,16.41,16.41,0,0,1-2.48,4,14.89,14.89,0,0,1-3.53,3.19,18.08,18.08,0,0,1-5.11,1.85s0,.11,0,.1a21,21,0,0,0,5.38-1.69A15,15,0,0,0,151,94.82a11.83,11.83,0,0,0,2.65-4.21,10.19,10.19,0,0,0,.29-4.69C154,85.81,153.76,85.82,153.78,85.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.7,104.65s-3.38-5.49-5.85-4.32-.15,9,2.6,10.21a2.86,2.86,0,0,0,3.92-1.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57,102.56s-.06,0,0,.07c1.93.91,2.86,2.8,3.47,4.74a1.58,1.58,0,0,0-2.33-.57.06.06,0,0,0,0,.11,1.77,1.77,0,0,1,1.9.73,8.57,8.57,0,0,1,.84,1.62c.08.18.4.11.35-.1l0,0C138,106.6,136.26,103,133.57,102.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,86.66c1.4-.53,2.74-8.39-2.43-12.14s-11.8.53-9,7C128,85.57,134.69,87.77,137.67,86.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,74.06a8.79,8.79,0,0,0-3,5,5.31,5.31,0,0,0,1.57,5.07,10.63,10.63,0,0,0,5.14,2.51,16.08,16.08,0,0,0,2.95.37,8.37,8.37,0,0,0,3-.33,7.27,7.27,0,0,1-3,.88,13.66,13.66,0,0,1-3.13-.05,10.43,10.43,0,0,1-5.76-2.57,6.15,6.15,0,0,1-1.7-2.82,6.21,6.21,0,0,1,.06-3.26A7.72,7.72,0,0,1,128,74.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,175.25c3.23,1,.08,28.07-4.85,27.3-20.32-3.16-36.12-12.78-39.62-16.64-4.42-4.87-4.07-9.7-1.33-12.59C94.42,169.12,133.06,174.22,136.26,175.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.66,172.35a47.29,47.29,0,0,0-12.25-.69c-.09,0-.1.15,0,.15,6.45.28,10.22.76,12.28.91C117.32,172.76,117.87,172.64,116.66,172.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,201.46c9.67,3.24,21.52,7.85,32.77,5.46a5.67,5.67,0,0,0,3.24-1.85c5.06-1,6.12-3.67,6.12-3.67,4.43-2.36,5.14-5.25,5.14-5.25s5.93-1.22,5.79-4.93c-.15-4.16-8.45-1.63-13.86-3-12.41-3.22-31-11.74-34.45-13Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,193.94a84.26,84.26,0,0,0,11,2.2,84.31,84.31,0,0,0,12.31-.1.1.1,0,0,1,0,.2,43.55,43.55,0,0,1-23.4-2.14C150.74,194,150.77,193.89,151,193.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92,201.14c3.62.65,10,1.76,21.31.13,0,0,.06,0,0,.06a39.05,39.05,0,0,1-21.36,0C147.67,201.26,147.68,201.1,147.92,201.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,205.05c6.19.87,10.21.64,16.73,0,0,0,.06.06,0,.07-7.34,1.52-10.18,1.24-16.81.15C146.08,205.22,146.12,205,146.37,205.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,180.7c15.67-4.52,60.74-1.89,60.94,8.88.24,12.83-69.36,12.29-69.38,3.61,0-4.83,16.06-4.13,16-6.95C162.13,184.09,149.06,182.3,154.6,180.7Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,180.7c15.67-4.52,60.74-1.89,60.94,8.88.24,12.83-69.36,12.29-69.38,3.61,0-4.83,16.06-4.13,16-6.95C162.13,184.09,149.06,182.3,154.6,180.7Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,179.57c15.67-4.52,60.74-1.89,60.94,8.88.24,12.83-69.36,12.29-69.38,3.61,0-4.83,16.06-4.13,16-6.94C162.13,183,149.06,181.17,154.6,179.57Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,179.57c15.67-4.52,60.74-1.89,60.94,8.88.24,12.83-69.36,12.29-69.38,3.61,0-4.83,16.06-4.13,16-6.94C162.13,183,149.06,181.17,154.6,179.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,190.05a4.57,4.57,0,0,1,2.55,1.25,1.65,1.65,0,0,1-.28,2.62c-2,1.29-7.24,1.06-7.81-1.9C162.13,189.33,165.77,189.43,168.18,190.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.55,193.88l-.29-.12a3.36,3.36,0,0,1-.89-.44,2,2,0,0,1-.65-.74,1,1,0,0,1-.17-.62,1.58,1.58,0,0,1,1-1.44,9.12,9.12,0,0,1,2.9-.52c1.42-.22,2.43-1.07,3.91-.95,1.63.14,3.54,1,3.87,2.48C191.1,195.45,182.74,194.68,180.55,193.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,183c.55,1.46,2.15,1.45,3.47,1.4s2.63-.08,3.94-.14a4,4,0,0,0,2.45-.53l.11-.13a1.18,1.18,0,0,0,.57-1.33c-.19-1.16-1.38-1.47-2.47-1.69a7.49,7.49,0,0,0-1.18-.26c-1.78-.48-3.79-1.35-5.57-.41A2.57,2.57,0,0,0,169.12,183Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06,181.08c-1.61,2,1.39,3.51,3,3.68s6.11.42,5.88-2c-.12-1.47-1.69-1.95-3.2-2C189.76,180.06,187.15,179.72,186.06,181.08Z",
    style: {
      fill: "#1E293B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.46,185.88c1.89,2.2-.66,4.65-2.82,5.06a21.55,21.55,0,0,1-5.14.13,2.48,2.48,0,0,1-2.52-1.69c-.49-2.33,1.8-3.23,3.93-3.57C203.18,184.79,206,184.12,207.46,185.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,183.37c-1.45-1.06-.9-1.83,2.29-1.94s15.91,2.14,16.32-2.36-17.55-6.56-22.87-6.84a36.46,36.46,0,0,0-16.28,3.19C134.43,176.69,145,180.79,151.59,183.37Z",
    style: {
      fill: "#eb9481"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankCanva);
export default __webpack_public_path__ + "static/media/blank-canva.e5aa30b19a3ed507779b4a340c4ea6f8.svg";
export { ForwardRef as ReactComponent };